export const getEnv = (name: string) => {
  return window.configs[name] || process.env[name];
};
